import cx from 'classnames'
import { type FC, type MutableRefObject, useRef } from 'react'

import useBoundingClientRect from '../../../hooks/useBoundingClientRect'
import css from './DropDown.module.scss'
import type { Props as DropDownProps } from './types'

type Props = Pick<
  DropDownProps,
  | 'children'
  | 'contentMinWidth'
  | 'top'
  | 'right'
  | 'bottom'
  | 'closeOnMouseDown'
  | 'contentClassName'
  | 'type'
> & {
  buttonRef: MutableRefObject<HTMLDivElement | null>
  toggleOpen: (value?: boolean) => void
  shadow?: 'default' | 'toolbar-editor'
}

export const Content: FC<Props> = ({
  children,
  buttonRef,
  contentMinWidth,
  top,
  right,
  bottom,
  closeOnMouseDown,
  toggleOpen,
  contentClassName,
  type,
  shadow,
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const contentRect = useBoundingClientRect(contentRef)

  // @ts-expect-error
  const buttonRect = buttonRef.current.getBoundingClientRect()

  const styleTop = !bottom
    ? `${buttonRect.height + (top !== undefined ? top : 3)}px`
    : 'auto'

  const styleRight =
    right === 'center' && contentRect && buttonRect
      ? `-${(contentRect.width - buttonRect.width) / 2}px`
      : (right !== undefined && `${right}px`) || 'auto'

  const styleBottom = !top
    ? `${buttonRect.height + (bottom !== undefined ? bottom : 3)}px`
    : 'auto'

  const contentStyle = {
    top: styleTop,
    right: styleRight,
    bottom: styleBottom,
  }

  return (
    <div className={css.target} style={contentStyle} ref={contentRef}>
      <div
        style={{ minWidth: contentMinWidth ?? '192px' }}
        // @ts-expect-error
        className={cx(css.content, css[type], contentClassName, {
          [css.shadow]: shadow === 'default',
          [css.toolbarEditorShadow]: shadow === 'toolbar-editor',
        })}
        {...(closeOnMouseDown
          ? {
              onMouseDown: () => {
                toggleOpen(false)
              },
            }
          : {})}
      >
        {children[1](true, toggleOpen)}
      </div>
    </div>
  )
}
